import { FunctionComponent, MouseEventHandler, MouseEvent } from 'react'
import IconButton from '@mui/material/IconButton'
import PrintIcon from '@mui/icons-material/Print'
import { dismissPopover } from 'services/OverlayService'
import TealToolTip from 'components/TealToolTip'

const PrintButton: FunctionComponent<PrintButtonProps> = ({ pdfUrl, isLogged, setSignUpModalIsOpen }) => {
  const handleOnClick: MouseEventHandler<HTMLButtonElement> = (e: MouseEvent<HTMLElement>) => {
    dismissPopover(e.target)
    if (!isLogged) {
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    } else {
      const doc = window.open(pdfUrl)
      if (doc !== null) doc.print()
    }
  }

  return (
    <div className='mh2 mh1-m'>
      <TealToolTip title='Print' placement='top' arrow={false} bgColor='dark'>
        <IconButton
          size='small'
          onClick={handleOnClick}
          data-event-category='Download'
          data-event-action='Print'
          data-event-label={pdfUrl}
          classes={{ root: 'black', sizeSmall: 'f3 f4-t f5-m' }}
        >
          <PrintIcon fontSize='inherit' className='vm' />
        </IconButton>
      </TealToolTip>
    </div>
  )
}

interface PrintButtonProps {
  pdfUrl: string
  isLogged: boolean
  setSignUpModalIsOpen: (value: boolean) => void
}

export default PrintButton
